import { createSlice } from '@reduxjs/toolkit'
import { logout } from './authSlice'

/** The tenant the user is working in: { tenantId, name, status, role }. Sent as X-Tenant-Id. */
const tenantSlice = createSlice({
  name: 'tenant',
  initialState: {
    current: JSON.parse(localStorage.getItem('tenant') || 'null'),
  },
  reducers: {
    selectTenant: (state, action) => {
      state.current = action.payload
      if (action.payload) {
        localStorage.setItem('tenant', JSON.stringify(action.payload))
      } else {
        localStorage.removeItem('tenant')
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, (state) => {
      state.current = null
    })
  },
})

export const { selectTenant } = tenantSlice.actions
export const selectIsTenantAdmin = (state) => state.tenant.current?.role === 'TENANT_ADMIN'
export default tenantSlice.reducer
